// JavaScript Document
(function ($) {
    
    function animations() {
        var delay = 0;
        
        $('.shopify-section')
            .each(function (index, element) {
                $(element)
                    .addClass('animated')
                    .addClass('fadeIn')
                    .attr('data-delay', '100');
            });

        $('.shopify-section')
            .each(function (index, element) {
                function animate() {
                    var hT = $(element).offset().top,
                        hH = $(element).outerHeight(),
                        wH = $(window).height(),
                        wS = $(this).scrollTop();
    
                    if (wS > (hT - wH / 2) - 250) {
                        // For each section
                        if ($(element).attr('data-delay') != 'undefined' && !$(element).hasClass('immediate')) {
                            delay = $(element).attr('data-delay');
                        }
                        setTimeout(function () {
                            $(element).css('animation-play-state', 'running');
                        }, delay);
                    }
                }
                
                animate();
                $(window).scroll(function () {
                    animate();    
                });
            });
    }
    
    function homeSlider() {
        var target = '.template-index #shopify-section-1502414219325 ul.slides li:first-of-type .slideshow__text-wrap',
            imgSrc = "//www.timecentrejewellers.com.au/cdn/shop/t/9/assets/logo_image_only.png?v=86716909556149547571585707925",
            img = '<img class="logo_image" src="' + imgSrc + '" />';
            
        if( $(target).length ) {
            $(img).prependTo(target);
            $('#shopify-section-1502414219325 .slides').addClass('home_hero');
        }
    }
    
    function testimonials() {
        var target = '.testimonials-wr .owl-wrapper .owl-item',
            text, name, starsContainer, starsCount, stars;
        
        if( $(target).length ) {
            $(target).each(function(index, element) {
                text = $(element).find('.rte-setting');
                name = $(element).find('cite');
                $(name).insertBefore(text);
            });
        }
    }
    
    function instagram() {
        var target = '#instafeed a', 
            target2 = '#insta-feed a',
            width,
            href;
        
        function calc() {
            var checkExist = setInterval(function() {
                if( $(target).length ) {
                    $(target).each(function(index, element) {
                        if(index === 0) {
                            width = $(element).width();
                        }
                        $(element).height(width);
                        clearInterval(checkExist);
                        $(element).on('click', function(e) {
                            e.preventDefault();
                            href = $(element).attr('href');
                            window.open(href, '_blank');
                        });
                    });
                }
            }, 100);
            
            var checkExist2 = setInterval(function() {
                if( $(target2).length ) {
                    $(target2).each(function(index, element) {
                        if(index === 0) {
                            width = $(element).width();
                        }
                        $(element).height(width);
                        clearInterval(checkExist2);
                        $(element).on('click', function(e) {
                            e.preventDefault();
                            href = $(element).attr('href');
                            window.open(href, '_blank');
                        });
                    });
                }
            }, 100);
        }
        
        calc();
        $(window).resize(function() {
            calc();
        });
    }
    
    function screenMenu() {
        var target = '.header_menu_button',
            social = '#shopify-section-footer .footer-icon-share',
            text = '#shopify-section-footer .footer_text',
            dest = '.footer_info_container';
            
        $(social).clone().appendTo(dest);
        $(text).clone().appendTo(dest);
        
        $(target).on('click', function() {
            $('body').toggleClass('screen_menu_open');
        });
    }
    
    function readMore() {
        var readMore = 'a.read_more',
            readMoreContent = '.read_more_content';
            
        $(readMore).each(function(index, element) {
            $(readMoreContent).each(function(index2, element2) {
                $(element).click(function() {
                    if( index === index2 ) {
                        $(element2).slideToggle();
                    }
                });
            });
        });
    }
    
    function featureRowImages() {
        var target = '.feature-row__item';
        
        $(target).each(function(index, element) {
            $(element).children().wrapAll('<div class="contained"></div>');
            if( $(element).find('.contained > img').length ) {
                $(element).addClass('img_container');
            }
        });
    }
    
    function swapImageRows() {
        function swap() {
            var target = '.img_container';
            
            $(target).each(function(index, element) {
                if( $(document).width() <= 767 ) {
                    if( $(element).prev().hasClass('feature-row__text') ) {
                        $(element)
                            .addClass('swapped')
                            .insertBefore( $(element).prev() );
                    } 
                } else {
                    if( $(element).hasClass('swapped') ) {
                        $(element)
                            .removeClass('swapped')
                            .insertAfter($(element).next());
                    }
                }
            });
        }
        
        swap();
        $(window).resize(function() {
            swap();
        });
    }
    
    function headerNumber() {
        var target = '.header_number',
            imgSrc = "//www.timecentrejewellers.com.au/cdn/shop/t/9/assets/phone.svg?v=120458521925482593221585707940",
            cart = '.header_cart_icon',
            cartSrc = "//www.timecentrejewellers.com.au/cdn/shop/t/9/assets/cart.svg?v=34596613359517128141586321874",
            img,
            cartImg;
        
        if( $('body').hasClass('template-product') ) {
            imgSrc = "//www.timecentrejewellers.com.au/cdn/shop/t/9/assets/phone_black.svg?v=3753868778626827261586324513";
            cartSrc = "//www.timecentrejewellers.com.au/cdn/shop/t/9/assets/cart_black.svg?v=62969141531781105051586324504";
        }
            
        img = '<img class="phone_image" width="25" height="25" src="' + imgSrc + '" />',
        cartImg = '<img class="cart_image" width="33" height="33" src=' + cartSrc + '">/';
            
        $(img).appendTo(target);
        $(cartImg).appendTo(cart);
    }
    
    function brandsCarousel() {
        var target = '#logo-brand';
        
        if( $(target).length ) {
            $("#logo-brand").owlCarousel({
                items: 5,
                loop: true,
                nav: false,
                slideSpeed: 500,
                autoPlay: 5000,
                stopOnHover: true
            });
        }
    }
    
    function markFullyLoaded() {
        var target = 'body';
        
        setTimeout(function() {
            $(target).addClass('fully_loaded');
        },750);
    }
    
    function contactMap() {
        var target = '.contact_map',
            form = '#shopify-section-contact-form';
        
        if( $(target).length ) {
            $(target).insertAfter(form);
        }
    }
    
    function slideLinks() {
        var target = '#shopify-section-1540169960838 .flexslider .slide',
            buttonLink;
        
        if( $(target).length ) {
            $(target).each(function(index, element) {
                buttonLink = $(target).find('.button-slide-1 a').attr('href');
                $(element).children().wrapAll('<a href="' + buttonLink + '" class="full_link"></a>');
            });
        }
    }
    
    function footerSocial() {
        var target = '.footer-icon-share a';
        
        $(target).each(function(index, element) {
            $(element).attr('target', '_blank');
        });
    }
    
    function specialsHeaderLink() {
        var target = '#shopify-section-1540169685178 h4',
            wrap = '<a style="color:#000000 !important;" href="/pages/specials/"></a>';
            
        $(target).wrap(wrap);
    }
    
    function fixLoadButton() {
        var target = '.infinite-scrolling .loading-more';
        if( $(target).length ) {
            if( $(target).text() === "loadding......" ) {
                $(target).text("Loading...");
            }
        }
    }
  
  	function productDescription() {
    	var target = '.template-product .product-shop .short-description';
      	if( $(target).length ) {
          setTimeout(function() {
        	var from = '.template-product .product-tabs .tab-content .tab-pane.active';
          	$(target).html( $(from).html() );
          },1000);
      	}
  	}
  
  	function searchToggle() {
        var target = '.header_search_icon';
        var close = '.search-close';

        if ($(target).length) {
            $(target).click(function (e) {
                e.preventDefault();
                $('body').toggleClass('show-search-form');
            });
        }

        if ($(close).length) {
            $(close).click(function (e) {
                e.preventDefault();
                $('body').removeClass('show-search-form');
            });
        }

    }

    // RUN THESE ON PAGE LOAD
    $(document).ready(function() {
        homeSlider();
        testimonials();
        instagram();
        screenMenu();
        readMore();
        featureRowImages();
        swapImageRows();
        headerNumber();
        brandsCarousel();
        contactMap();
        slideLinks();
        footerSocial();
        specialsHeaderLink();
        fixLoadButton();
      	productDescription();
        
        markFullyLoaded();
        animations();
        searchToggle();
    });
    
}(window.jQuery || window.$));